module.exports = __webpack_public_path__ + "static/media/jayesh.344edb59.jpg";